import firebase from 'firebase/app';
import 'firebase/firestore';
import "firebase/auth"


const firebaseConfig = {
  apiKey: "AIzaSyDlZ2lSI_mLGGyxsrRMFU6Ms-biX_jIPgk",
  authDomain: "zephyris-20616.firebaseapp.com",
  databaseURL: "https://zephyris-20616-default-rtdb.firebaseio.com",
  projectId: "zephyris-20616",
  storageBucket: "zephyris-20616.appspot.com",
  messagingSenderId: "947363976635",
  appId: "1:947363976635:web:5b9dc908b458dcdbefa09e",
  measurementId: "G-RT3W4W2S6T"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();


export {auth,provider};
export default db;